import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import classNames from 'classnames';
import { Dropdown, DropdownMenu, DropdownMenuItem, DropdownMenuSeparator } from '../../components/Dropdown';
import { Icon } from '../../components/Icon';
import { Alignment } from '../../components/Popup';
import PopupArrow from '../../components/Popup/PopupArrow';
import getSafeImageSource from '../../utils/getSafeImageSource';
import { DefaultImage, DefaultLink } from '../shared';
import commonStyles from '../shared/styles.module.css';
import defaultProfile from './default-profile.svg';
import type { MenuItemComponent, UserInfoProps, UserLink } from './types';
import useLinkItemActive from './useLinkItemActive';
import styles from './UserInfo.module.css';
const profile = getSafeImageSource(defaultProfile);
function MenuItem({
  link,
  Link,
  shouldSetActiveClass = false,
  MenuItemComponent
}: {
  link: UserLink;
  Link: React.FC<any>;
  MenuItemComponent: MenuItemComponent;
  shouldSetActiveClass?: boolean;
}) {
  const active = useLinkItemActive(link);
  if (link === 'separator') return <DropdownMenuSeparator />;
  return <MenuItemComponent>
      <Link data-axe-expect="color-contrast" className={classNames(styles.link, {
      [styles.active as string]: shouldSetActiveClass && active
    })} href={link.href}>
        {link.name}
      </Link>
    </MenuItemComponent>;
}
function UserInfo(t0) {
  const $ = _c(21);
  const {
    text: t1,
    Link: t2,
    Image: t3
  } = t0;
  const {
    avatar: t4,
    name,
    links,
    myProfile
  } = t1;
  const avatarImage = t4 === undefined ? profile : t4;
  const Link = t2 === undefined ? DefaultLink : t2;
  const Image = t3 === undefined ? DefaultImage : t3;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classNames(styles.trigger, styles.login, commonStyles.navigationLink);
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  const t6 = `${name} - Avatar`;
  let t7;
  if ($[1] !== Image || $[2] !== avatarImage || $[3] !== t6) {
    t7 = <Image className={styles.image} height={36} width={36} src={avatarImage} alt={t6} />;
    $[1] = Image;
    $[2] = avatarImage;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== myProfile) {
    t8 = <span className={styles.label}>{myProfile}</span>;
    $[5] = myProfile;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Icon name="chevronDown" size="400" color="fg-content-primary" className={styles.caret} />;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t7 || $[9] !== t8) {
    t10 = <button data-axe-expect="aria-valid-attr-value" className={t5} id="header-login-dropdown-toggle">{t7}{t8}{t9}</button>;
    $[8] = t7;
    $[9] = t8;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== Link || $[12] !== links) {
    let t12;
    if ($[14] !== Link) {
      t12 = (link, index) => <MenuItem link={link} Link={Link} key={index} MenuItemComponent={DropdownMenuItem} />;
      $[14] = Link;
      $[15] = t12;
    } else {
      t12 = $[15];
    }
    t11 = links.map(t12);
    $[11] = Link;
    $[12] = links;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[16] !== t11) {
    t12 = <DropdownMenu>{t11}</DropdownMenu>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t12) {
    t13 = <Dropdown wrapperClassName={styles.dropdownMenu} Anchor={PopupArrow} marginInPx={5} id="user-info-dropdown" anchorClassName={styles.arrow} alignContent={Alignment.RIGHT} trigger={t10}>{t12}</Dropdown>;
    $[18] = t10;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
}
export default UserInfo;